const options = [
  {
    value: 1,
    label: "时间"
  },
  {
    value: 2,
    label: "门店"
  },
  {
    value: 3,
    label: "顾客"
  },
  {
    value: 4,
    label: "会员"
  },
  {
    value: 5,
    label: "客流渠道"
  },
  {
    value: 6,
    label: "预约渠道"
  },
  {
    value: 7,
    label: "项目"
  },
  {
    value: 8,
    label: "储值卡"
  },
  {
    value: 9,
    label: "理疗师"
  }
];
const performanceHeader = [
  // 效率概况
  {
    name: "eff_survey",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [true, true, false, false, false],
    // 时间，门店，顾客，会员
    options: options,
    twoRow: false
  },
  // 效率趋势
  {
    name: "eff_trend",
    contrast: true,
    quckTime: "MonthTabTen",
    datePicker: "DatePicker",
    time: "",
    headerShow: [true, true, false, false, false],
    // 时间，门店，顾客，会员
    options: options,
    twoRow: false
  },
  // 效率增长
  {
    name: "eff_target",
    contrast: false,
    quckTime: "MonthTab",
    datePicker: "MonthPicker",
    headerShow: [true, true, false, false, false, false, false, false],
    options: options,
    twoRow: false
  },
  // 效率分析
  {
    name: "eff_therapist",
    contrast: false,
    quckTime: "MonthTabThree",
    datePicker: "DatePicker",
    headerShow: [true, true, false, false, false, false, false, false],
    options: options,
    twoRow: true
  },
  // 门店对比
  {
    name: "eff_store",
    contrast: false,
    quckTime: "MonthTabTen",
    datePicker: "DatePicker",
    time: "",
    headerShow: [true, true, false, false, false],
    // 时间，门店，顾客，会员
    options: options,
    twoRow: false
  },
  // 理疗师概况
  {
    name: "perform_survey",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [true, false, false, false, false, false, false, false, true],
    options: options
    // twoRow: false
  },
  // 理疗师详情
  {
    name: "perform_analyze",
    contrast: true,
    quckTime: "MonthTabFive",
    datePicker: "DatePicker",
    headerShow: [true, false, false, false, false, false, false, false, true],
    options: options
  },
  // 理疗师增长
  {
    name: "perform_target",
    contrast: false,
    quckTime: "MonthTab",
    datePicker: "MonthPicker",
    headerShow: [true, false, false, false, false, false, false, false, true],
    options: options
  },
  // 理疗师对比
  {
    name: "perform_contrast",
    contrast: false,
    quckTime: "MonthTabTen",
    datePicker: "DatePicker",
    time: "",
    headerShow: [true, false, false, false, false, false, false, false, true],
    // 时间，门店，顾客，会员
    options: options
  },
  // 前台概况
  {
    name: "front_survey",
    contrast: false,
    quckTime: "",
    datePicker: "",
    time: "Month",
    headerShow: [true, false, false, false, false, false, false, false, false, true],
    options: options
    // twoRow: false
  },
  // 前台详情
  {
    name: "front_detail",
    contrast: true,
    quckTime: "MonthTabFive",
    datePicker: "DatePicker",
    headerShow: [true, false, false, false, false, false, false, false, false, true],
    options: options
  },
  // 前台增长
  {
    name: "front_analyze",
    contrast: false,
    quckTime: "MonthTab",
    datePicker: "MonthPicker",
    headerShow: [true, false, false, false, false, false, false, false, false, true],
    options: options
  },
  // 前台对比
  {
    name: "front_contract",
    contrast: false,
    quckTime: "MonthTabTen",
    datePicker: "DatePicker",
    time: "",
    headerShow: [true, false, false, false, false, false, false, false, false, true],
    // 时间，门店，顾客，会员
    options: options
  },
];
const performanceContent = [
  // 效率概况
  {
    name: "eff_survey",
    value: [
      {
        name: "eff_survey",
        xname: "SurveyTherapist",
        selectChart: "",
        selectTable: "SelectClass",
        normalTable: "ColorTables",
        oneChart: "",
        chartKey: "",
        tableTitle: "门店",
        tableKey: "efficiency_therapist_general",
        tableAddress: "bottom",
        tableNum: "4",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        focus: 2,
        headerType: 4,
        constantKey: "",
        parentID: -1,
        TableconstantType: 8,
        type: 1,
        dateFormat: 1,
        chartZoom: false,
        isTableKey: true,
        isIndex: true,
        sortIndex: 1
      },
      {
        xname: "SurveyReceptionist",
        selectTable: "SelectClass",
        tableKey: "efficiency_frontemp_general",
        normalTable: "ColorTables",
        TableconstantType: 8,
        headerType: 4,
      },
      {
        xname: "SurveySpace",
        selectTable: "SelectClass",
        tableKey: "efficiency_space_general",
        normalTable: "ColorTables",
        TableconstantType: 8,
        headerType: 4,
      },
      {
        xname: "SurveyRoom",
        selectTable: "SelectClass",
        tableKey: "rooms_general_in_efficiency_analysis",
        normalTable: "DateTable",
        TableconstantType: 8,
        headerType: 2,
      },
      {
        headerType: 2,
        TableconstantType: 5,
        xname: "SurveyArea",
        selectTable: "SelectDrop",
        tableKey: "area_general_in_efficiency_analysis",
        normalTable: "AreaTable"
      }
    ]
  },
  // 效率趋势
  {
    name: "eff_trend",
    value: [
      {
        name: "eff_trend",
        xname: "trendTherapist",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "ContrantTable",
        oneChart: "VueHighchart",
        firstChart: "",
        tableTitle: "日期",
        secondChart: "",
        compareChart: "",
        chartKey: "darwing_trend_of_efficiency_trend",
        tableKey: "key_and_table_of_efficiency_trend",
        chartAddress: "",
        tableAddress: "bottom",
        chartNum: "2",
        tableNum: "6",
        isTwo: false,
        isDay: true,
        isTime: true,
        isChart: true,
        isTable: true,
        headerType: 2,
        TableconstantType: 1,
        ChartconstantType: 1,
        constantKey: "",
        parentID: 0,
        dateFormat: 1,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        sortIndex: 1
      },
      {
        xname: "trendReceptionist",
        headerType: 2,
        TableconstantType: 1,
        ChartconstantType: 1,
        tableNum: "5",
        selectTable: "SelectDrop",
        chartKey: "darwing_trend_of_frontemp_efficiency_trend",
        tableKey: "key_and_table_of_frontemp_efficiency_trend",
        normalTable: "DateTable"
      },
      {
        xname: "trendSpace",
        headerType: 2,
        TableconstantType: 1,
        ChartconstantType: 1,
        tableNum: "5",
        selectTable: "SelectDrop",
        chartKey: "darwing_trend_of_space_efficiency_trend",
        tableKey: "key_and_table_of_space_efficiency_trend",
        normalTable: "DateTable"
      },
    ]
  },
  // 效率增长
  {
    name: "eff_target",
    value: [
      {
        name: "eff_target",
        xname: "RatioOne",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "ContrantTable",
        oneChart: "VueColumn",
        chartKey: "bar_of_mom_in_efficiency_growth",
        tableKey: "key_and_table_mom_in_efficiency_growth",
        chartAddress: "center",
        tableAddress: "bottom",
        tableTitle: "日期",
        chartNum: "1",
        tableNum: "6",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        headerType: 2,
        constantKey: "",
        parentID: 0,
        TableconstantType: 3,
        ChartconstantType: 3,
        IndexCompareType: 1,
        type: 2,
        dateFormat: 2,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        sortIndex: 1
      },
      {
        xname: "RatioTwo",
        chartKey: "bar_of_yoy_in_efficiency_growth",
        tableKey: "key_and_table_yoy_in_efficiency_growth",
        type: 1
      }
    ]
  },
  // 效率分析
  {
    name: "eff_therapist",
    value: [
      {
        name: "eff_therapist",
        xname: "Productivity",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        normalTable: "",
        oneChart: "ChartHeatmap",
        chartKey: "time_distribution_of_emp_productivity",
        tableKey: "time_distribution_of_emp_productivity",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "1",
        tableNum: "6",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        chartZoom: false,
        isTableKey: false,
        constantKey: "period_time_of_busy_spare_analysis",
        constantKeyAxis: "dimensionality_weekDayCustFlow",
        isIndex: true,
        chartTitle: "理疗师生产率"
      },
      {
        xname: "busy",
        chartKey: "free_distribution_of_emp_productivity",
        tableKey: "free_distribution_of_emp_productivity",
        isIndex: false,
        chartTitle: "空闲理疗师人数"
      },
      {
        xname: "store",
        chartKey: "distribution_of_cust_in_stores",
        tableKey: "distribution_of_cust_in_stores",
        isIndex: true,
        chartTitle: "在店客人数"
      }
    ]
  },
  // 门店对比
  {
    name: "eff_store",
    value: [
      {
        name: "eff_store",
        xname: "index",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "",
        oneChart: "VueColumn",
        chartSort: true,
        firstChart: "",
        secondChart: "",
        compareChart: "",
        chartKey: "store_compare_of_efficiency_analysis_drawing",
        tableKey: "store_compare_of_efficiency_analysis_table_key",
        chartAddress: "center",
        tableAddress: "bottom",
        tableNum: "6",
        chartNum: "2",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        tableTitle: "门店",
        chartZoom: true,
        isTableKey: true,
        constantKey: "",
        headerType: 2,
        parentID: -1,
        TableconstantType: 8,
        ChartconstantType: 8,
        isIndex: true,
        sortIndex: 1
      }
    ]
  },
  // 理疗师概况
  {
    name: "perform_survey",
    value: [
      {
        name: "perform_survey",
        xname: "standard",
        selectChart: "",
        selectTable: "SelectClass",
        normalTable: "ColorTables",
        oneChart: "",
        chartKey: "",
        tableTitle: "理疗师",
        tableKey: "bench_index_emp_general",
        tableAddress: "bottom",
        tableNum: "4",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        focus: 2,
        headerType: 4,
        constantKey: "",
        parentID: -1,
        TableconstantType: 9,
        type: 2,
        chartZoom: false,
        isTableKey: true,
        isIndex: true,
        sortIndex: 2
      },
      {
        xname: "service",
        tableKey: "key_indicator_emp_general",
        normalTable: "ColorTables"
      },
      {
        xname: "results",
        tableKey: "performance_of_emp_general",
        normalTable: "ColorTables"
      }
    ]
  },
  // 理疗师详情
  {
    name: "perform_analyze",
    value: [
      {
        name: "perform_analyze",
        xname: "trend",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "ContrantTable",
        oneChart: "VueHighchart",
        firstChart: "",
        secondChart: "",
        compareChart: "",
        chartKey: "daily_trend_of_spaTherapist_analysis",
        tableKey: "daily_trend_of_spaTherapist_analysis",
        chartAddress: "center",
        tableAddress: "bottom",
        tableTitle: "日期",
        tableNum: "6",
        chartNum: "2",
        isTwo: false,
        isDay: false,
        isTime: true,
        isChart: true,
        isTable: true,
        chartZoom: true,
        isTableKey: true,
        constantKey: "",
        headerType: 2,
        parentID: 0,
        TableconstantType: 1,
        ChartconstantType: 1,
        // type: 1,
        dateFormat: 1,
        isIndex: true,
        sortIndex: 1
      },
      {
        xname: "allTrend",
        chartKey: "trend_of_emp",
        tableKey: "trend_of_emp",
        normalTable: "DateTable",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        compareTable: "ContrantTable",
        isDay: true,
        isTime: true,
        chartNum: "2",
        oneChart: "VueHighchart",
        compareChart: "",
        tableTitle: "日期",
        isTwo: false,
        constantKey: "",
        TableconstantType: 1,
        ChartconstantType: 1,
        headerType: 2,
        dateFormat: 1,
        parentID: 0
      },
      {
        xname: "save",
        chartKey: "retention_rate_emp_analysis_drawing",
        tableKey: "retention_rate_emp_analysis_table_key",
        normalTable: "OneTable",
        compareTable: "OneLevel",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        isDay: false,
        isTime: false,
        chartNum: "2",
        oneChart: "VueHighchart",
        compareChart: "",
        tableTitle: "日期",
        isTwo: false,
        constantKey: "",
        TableconstantType: 1,
        ChartconstantType: 1,
        // type: 1,
        dateFormat: 2,
        parentID: 0,
        headerType: 1
      },
      {
        xname: "customerClass",
        chartKey: "cust_type_of_spaTherapist_analysis_drawing",
        indicatorKey: "cust_type_of_spaTherapist_analysis_key",
        tableKey: "cust_type_of_spaTherapist_analysis_table",
        normalTable: "TableCard",
        compareTable: "OneLevel",
        selectChart: "SelectIndex",
        selectTable: "SelectDrop",
        isTime: true,
        isDay: false,
        chartNum: "1",
        oneChart: "",
        firstChart: "VuePie",
        secondChart: "AsideTrend",
        compareChart: "VuePie",
        tableTitle: "顾客类型",
        isTwo: true,
        constantKey: "cust_type_analysis_dimension",
        TableconstantType: 2,
        PieconstantType: 2,
        ChartconstantType: 4,
        parentID: -1,
        headerType: 1,
        dateFormat: 1
      },
      {
        xname: "evaluate",
        chartKey: "evaluation_of_spaTherapist_analysis_drawing",
        tableKey: "evaluation_of_spaTherapist_analysis_table_key",
        normalTable: "TableCard",
        compareTable: "OneLevel",
        isTime: true,
        isDay: false,
        chartNum: "1",
        oneChart: "",
        firstChart: "VuePie",
        secondChart: "AsideTrend",
        compareChart: "VuePie",
        tableTitle: "评价星级",
        isTwo: true,
        constantKey: "evaluation_emp_analysis_dimension",
        TableconstantType: 2,
        PieconstantType: 2,
        ChartconstantType: 4,
        parentID: -1,
        headerType: 1
      },
      {
        xname: "reward",
        chartKey: "reward_of_spaTherapist_analysis_drawing",
        tableKey: "reward_of_spaTherapist_analysis_table_key",
        normalTable: "TableCard",
        compareTable: "OneLevel",
        isTime: true,
        isDay: false,
        chartNum: "1",
        oneChart: "",
        firstChart: "VuePie",
        secondChart: "AsideTrend",
        compareChart: "VuePie",
        tableTitle: "打赏金额",
        isTwo: true,
        constantKey: "reward_emp_analysis_dimension",
        TableconstantType: 2,
        PieconstantType: 2,
        ChartconstantType: 4,
        parentID: -1,
        headerType: 1
      },
      {
        xname: "card",
        chartKey: "open_card_of_spaTherapist_analysis_drawing",
        tableKey: "open_card_of_spaTherapist_analysis_table_key",
        normalTable: "TableCard",
        compareTable: "OneLevel",
        isTime: true,
        isDay: false,
        chartNum: "1",
        oneChart: "",
        firstChart: "VuePie",
        secondChart: "AsideTrend",
        compareChart: "VuePie",
        tableTitle: "办卡金额",
        isTwo: true,
        constantKey: "open_card_emp_analysis_dimension",
        TableconstantType: 2,
        PieconstantType: 2,
        ChartconstantType: 4,
        parentID: -1,
        headerType: 1
      }
    ]
  },
  // 理疗师增长
  {
    name: "perform_target_trend",
    value: [
      {
        name: "perform_target_trend",
        xname: "RatioOne",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "ContrantTable",
        oneChart: "VueColumn",
        chartKey: "table_mom_team",
        tableKey: "table_mom_team",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "1",
        tableNum: "6",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        headerType: 2,
        constantKey: "",
        parentID: 0,
        TableconstantType: 3,
        ChartconstantType: 3,
        IndexCompareType: 1,
        type: 2,
        dateFormat: 2,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        tableTitle: "日期",
        sortIndex: 1
      },
      {
        xname: "RatioTwo",
        chartKey: "table_yoy_team",
        tableKey: "table_yoy_team",
        type: 1
      },
      {
        xname: "standard",
        chartKey: "table_benchmark_team",
        tableKey: "table_benchmark_team",
        type: 4
      }
    ]
  },
  // 理疗师对比
  {
    name: "perform_contrast",
    value: [
      {
        name: "perform_contrast",
        xname: "result",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "ContrantTable",
        oneChart: "VueColumn",
        chartSort: true,
        firstChart: "",
        secondChart: "",
        compareChart: "",
        chartKey: "histogram_spaTherapist_com",
        tableKey: "table_of_spaTherapist_com",
        chartAddress: "center",
        tableAddress: "bottom",
        tableNum: "30",
        chartNum: "2",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        tableTitle: "理疗师",
        chartZoom: false,
        isTableKey: false,
        constantKey: "",
        headerType: 2,
        parentID: -1,
        TableconstantType: 10,
        ChartconstantType: 10,
        dateFormat: 1,
        isIndex: true,
        sortIndex: 1
      },
      {
        xname: "service",
        chartKey: "histogram_spaTherapist_service_com",
        tableKey: "table_of_spaTherapist_service_com"
      }
    ]
  },
  // 前台概况
  {
    name: "front_survey",
    value: [
        // 日均概况
      {
        name: "front_survey",
        xname: "standard",
        selectChart: "",
        selectTable: "SelectClass",
        normalTable: "ColorTables",
        oneChart: "",
        chartKey: "",
        tableTitle: "前台",
        tableKey: "bench_index_frontemp_general",
        tableAddress: "bottom",
        tableNum: "4",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: false,
        isTable: true,
        focus: 2,
        headerType: 4,
        constantKey: "",
        parentID: -1,
        TableconstantType: 9,
        type: 2,
        chartZoom: false,
        isTableKey: true,
        isIndex: true,
        sortIndex: 2
      },
    //   服务概况
    //   {
    //     xname: "service",
    //     tableKey: "key_indicator_emp_general",
    //     normalTable: "ColorTables"
    //   },
    //   业绩概况
      {
        xname: "results",
        tableKey: "performance_of_frontemp_general",
        normalTable: "ColorTables"
      }
    ]
  },
  // 前台详情
  {
    name: "front_detail",
    value: [
      {
        name: "front_detail",
        xname: "trend",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "ContrantTable",
        oneChart: "VueHighchart",
        firstChart: "",
        secondChart: "",
        compareChart: "",
        chartKey: "daily_trend_of_frontemp_analysis",
        tableKey: "daily_trend_of_frontemp_analysis",
        chartAddress: "center",
        tableAddress: "bottom",
        tableTitle: "日期",
        tableNum: "6",
        chartNum: "2",
        isTwo: false,
        isDay: false,
        isTime: true,
        isChart: true,
        isTable: true,
        chartZoom: true,
        isTableKey: true,
        constantKey: "",
        headerType: 2,
        parentID: 0,
        TableconstantType: 1,
        ChartconstantType: 1,
        // type: 1,
        dateFormat: 1,
        isIndex: true,
        sortIndex: 1
      },
      {
        xname: "allTrend",
        chartKey: "trend_of_frontemp",
        tableKey: "trend_of_frontemp",
        normalTable: "DateTable",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        compareTable: "ContrantTable",
        isDay: true,
        isTime: true,
        chartNum: "2",
        oneChart: "VueHighchart",
        compareChart: "",
        tableTitle: "日期",
        isTwo: false,
        constantKey: "",
        TableconstantType: 1,
        ChartconstantType: 1,
        headerType: 2,
        dateFormat: 1,
        parentID: 0
      },
    ]
  },
  // 前台增长
  {
    name: "front_analyze",
    value: [
      {
        name: "front_analyze",
        xname: "RatioOne",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "ContrantTable",
        oneChart: "VueColumn",
        chartKey: "table_mom_frontteam",
        tableKey: "table_mom_frontteam",
        chartAddress: "center",
        tableAddress: "bottom",
        chartNum: "1",
        tableNum: "6",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        headerType: 2,
        constantKey: "",
        parentID: 0,
        TableconstantType: 3,
        ChartconstantType: 3,
        IndexCompareType: 1,
        type: 2,
        dateFormat: 2,
        chartZoom: true,
        isTableKey: true,
        isIndex: true,
        tableTitle: "日期",
        sortIndex: 1
      },
      {
        xname: "RatioTwo",
        chartKey: "table_yoy_frontteam",
        tableKey: "table_yoy_frontteam",
        type: 1
      },
      {
        xname: "standard",
        chartKey: "table_benchmark_frontteam",
        tableKey: "table_benchmark_frontteam",
        type: 4
      }
    ]
  },
  // 前台对比
  {
    name: "front_contract",
    value: [
      {
        name: "front_contract",
        xname: "result",
        selectChart: "SelectChart",
        selectTable: "SelectClass",
        normalTable: "DateTable",
        compareTable: "ContrantTable",
        oneChart: "VueColumn",
        chartSort: true,
        firstChart: "",
        secondChart: "",
        compareChart: "",
        chartKey: "histogram_frontemp_com",
        tableKey: "histogram_frontemp_com",
        chartAddress: "center",
        tableAddress: "bottom",
        tableNum: "30",
        chartNum: "2",
        isTwo: false,
        isDay: false,
        isTime: false,
        isChart: true,
        isTable: true,
        tableTitle: "前台",
        chartZoom: false,
        isTableKey: false,
        constantKey: "",
        headerType: 2,
        parentID: -1,
        TableconstantType: 10,
        ChartconstantType: 10,
        dateFormat: 1,
        isIndex: true,
        sortIndex: 1
      }
    ]
  }
];
export { performanceHeader, performanceContent };
